import { Ref } from 'react';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '../TextCutter';

export interface ErrorMessageProps {
  lines?: number;
  message?: string;
  className?: string;
  ref?: Ref<HTMLParagraphElement>;
}

export const ErrorMessage = ({ className, message, lines = 1, ref }: ErrorMessageProps) =>
  message ? (
    <TextCutter
      ref={ref}
      lines={lines}
      className={cn('absolute left-0 pt-0.5 pl-[inherit] text-[11px] text-error', className)}
      text={`* ${message}`}
    />
  ) : null;
